import { $ } from '@starberry/components';

export default {
  $: 'Stack',

  props: {
    direction: 'row',
    spacing: 0,
    display: {
      base: 'flex',
      md: 'none',
    },
    justifyContent: 'space-between',
    position: 'fixed',
    bottom: 0,
    height: 65,
    width: '100vw',
    backgroundColor: $('constants.sidebarBgColor'),
    px: 5,
    zIndex: 999,
  },

  children: ({ sideNav }) =>
    sideNav.map(({ visibility, ...item }) => ({
      ...item,
      iconOnly: true,
      linkProps: {
        justifyContent: 'center',
      },
      props: {
        ...item.props,
        width: 20,
        padding: 0,
        display: visibility?.tabs ? 'flex' : 'none',
      },
    })),
};
